import { Outlet } from "react-router-dom";
import { BrandLogo } from "@/components/brand/BrandLogo";

export function PublicShell() {
  return (
    <div className="min-h-screen bg-canvas">
      <header className="border-b border-border bg-white">
        <div className="mx-auto flex h-16 max-w-5xl items-center px-4 sm:px-6">
          <BrandLogo compact subtitle="Secure invoice portal" />
        </div>
      </header>
      <main className="mx-auto max-w-5xl px-4 py-6 sm:px-6 sm:py-10">
        <Outlet />
      </main>
    </div>
  );
}
